class CarouselItems extends HTMLElement {
    constructor() {
        super();
        this.index = 0;
        this.drag = {
            x: 0,
            y: 0,
        };

        // this.addEventListener('dragstart', debounce(this.onDragChanged.bind(this), 500));
        // this.addEventListener('dragover', debounce(this.onDragChanged.bind(this), 500));
        this.addEventListener('touchstart', debounce(this.onDragChanged.bind(this), 500), { passive: true });
        this.addEventListener('touchend', debounce(this.onDragChanged.bind(this), 500), { passive: true });
        this.addEventListener('mouseenter', debounce(this.stopInterval.bind(this), 500), { passive: true });
        this.addEventListener('mouseover', debounce(this.stopInterval.bind(this), 500), { passive: true });
        this.addEventListener('mouseleave', debounce(this.startInterval.bind(this), 500), { passive: true });

        this.elements = {
            indicator: this.querySelector("[id^=Carousel_Indication_]"),
            switcher: this.querySelector("[id^=Carousel_Switchers_]"),
            scrollHolder: this.querySelector("[id^=Carousel_Scroll_holder_]")
        };

        if (this.elements?.scrollHolder?.querySelectorAll(".ml_carousel_item")?.[this.index]) {
            this.elements.scrollHolder.querySelectorAll(".ml_carousel_item")[this.index].querySelectorAll("a, button").forEach(el => {
                el.tabIndex = 0;
            })
        }

        this.length = this.elements.indicator?.querySelectorAll("li")?.length;
        if (this.elements.scrollHolder?.querySelectorAll(".ml_carousel_item")?.length > 0) {
            this.startInterval();
        }

        const that = this;
        this.elements.indicator?.querySelectorAll("li")?.forEach(
            el => {
                el.addEventListener("click", (e) => {
                    that.specificItem(el.dataset.index);
                }, { passive: true })
                el.onkeypress = (e) => {
                    if (e.key === "Enter") {
                        el.click();
                    }
                }
            }
        )
        this.elements.switcher?.querySelector(`#next_${this.dataset.sectionId}`)?.addEventListener("click", (e) => {
            that.nextItem();
        }, { passive: true });
        this.elements.switcher?.querySelector(`#previous_${this.dataset.sectionId}`)?.addEventListener("click", (e) => {
            that.prevItem();
        }, { passive: true });
    }

    startInterval() {
        if (this.dataset.slideshow == 'true' && this.dataset.interval) {
            this.interval = setInterval(() => {
                this.nextItem();
            }, this.dataset.interval * 1000);
        }
    }

    stopInterval() {
        clearInterval(this.interval);
    }

    restartInterval() {
        this.stopInterval();
        this.startInterval();
        // setTimeout(() => {
        // }, this.dataset.interval * 1000)
    }

    onDragChanged(event) {
        if (event.type == 'dragstart' || event.type == 'touchstart') {
            this.drag = {
                x: event.x,
                y: event.y
            }
        } else {
            if (this.drag.x != event.x) {
                if ((this.drag.x - event.x) < 0) {
                    this.prevItem();
                } else {
                    this.nextItem();
                }
            }
        }
    }

    nextItem() {
        const oldIndex = this.index;
        this.index = (this.index + 1) % this.length;
        this.handleChange(oldIndex);
    }

    prevItem() {
        const oldIndex = this.index;
        if (this.index - 1 < 0) {
            this.index = this.length - 1;
        } else {
            this.index -= 1;
        }
        this.handleChange(oldIndex);
    }

    specificItem(index) {
        const oldIndex = this.index;
        this.index = index;
        this.handleChange(oldIndex);
    }

    handleChange(oldIndex = 0) {
        if (this.elements?.scrollHolder?.querySelectorAll(".ml_carousel_item")?.[oldIndex]) {
            this.elements.scrollHolder.querySelectorAll(".ml_carousel_item")[oldIndex].querySelectorAll("a, button").forEach(el => {
                el.tabIndex = -1;
            })
        }
        const selectedItem = this.elements.scrollHolder?.querySelectorAll(".ml_carousel_item")?.[this.index];
        const img = selectedItem?.querySelector(".ml_img_holder");
        const info = selectedItem?.querySelector(".ml_product_info");
        const title = selectedItem?.querySelector(".ml_carousel_title");
        const action = selectedItem?.querySelector(".ml_carousel_actions");

        if(selectedItem) {
            selectedItem.querySelectorAll("a, button").forEach(el => {
                el.tabIndex = 0;
            })
        }

        if (info) {
            info.classList.remove("ml_animate_left");
            setTimeout(() => {
                info.classList.add("ml_animate_left");
            }, 0);
        }
        if (title) {
            title.classList.remove("ml_animate_left");
            setTimeout(() => {
                title.classList.add("ml_animate_left");
            }, 0);
        }
        if (action) {
            action.classList.remove("ml_animate_left");
            setTimeout(() => {
                action.classList.add("ml_animate_left");
            }, 0);
        }
        if (img) {
            img.classList.remove("ml_animate_right");
            setTimeout(() => {
                img.classList.add("ml_animate_right");
            }, 0);
        }

        setTimeout(() => {
            this.elements.scrollHolder.style.transform = `translateX(-${this.index * 100}%)`;
        }, 0);

        const oldImg = selectedItem?.querySelector(".ml_overlay_img_effect_trans");
        const oldImgUrl = this.elements?.scrollHolder?.querySelectorAll(".ml_carousel_item")?.[oldIndex]?.style;
        const svgHolder = this.querySelector('.svg_holder');
        if (oldImg) {
            oldImg.style.backgroundPosition = oldImgUrl.backgroundPosition;
            oldImg.style.backgroundImage = oldImgUrl.backgroundImage;
            oldImg.classList.add("show_ov");
            if (svgHolder) svgHolder.style.display = 'none';
            setTimeout(() => {
                oldImg.classList.remove("show_ov");
                if (svgHolder) svgHolder.style.display = 'flex';
            }, 250);
        }


        this.elements.indicator?.querySelectorAll("li")?.forEach(el => el.classList.remove("active"));
        this.elements.indicator?.querySelectorAll("li")?.[this.index].classList.add("active");
        if (this.interval) {
            this.restartInterval();
        }
    }
}
customElements.define('carousel-item', CarouselItems);